import { NarrowCurrencySymbolLocales } from "app/utils/const";
import cx from "classnames";
import { FormattedNumber } from "react-intl";
import { connect } from "react-redux";
import type { UserType } from "../../types/userType";
type Props = {
  id: string;
  value: number;
  className?: string;
  user: UserType;
  minimumFractionDigits: number;
  hideDecimalIfZeros?: boolean;
  narrowSymbol?: boolean;
  QAID?: string;
};

const CurrencyNumber = (props: Props) => {
  if (!isNaN(props.value)) {
    const userLocale = props?.user?.preferences?.language || "";
    const showNarrowSymbol = NarrowCurrencySymbolLocales.includes(userLocale);
    return (
      <span
        id={props.id}
        className={props.className && cx(props.className)}
        data-qa={props.QAID && props.QAID}
      >
        <FormattedNumber
          value={props.value}
          minimumFractionDigits={getMinimumFractionDigits(props)}
          maximumFractionDigits={2}
          style={`currency`}
          currency={props.user["currencyCode"]}
          // For certain currencies, show narrow symbol, eg $ instead of US$
          currencyDisplay={
            props.narrowSymbol && showNarrowSymbol ? "narrowSymbol" : "symbol"
          }
        />
      </span>
    );
  } else {
    return " - ";
  }
};

const mapStateToProps = state => ({
  user: state.userModel.user,
});

export default connect(mapStateToProps, null)(CurrencyNumber) as any;

const getMinimumFractionDigits = props => {
  // if minimumFractionDigits is not set in props, use a default of 2 decimal places
  // unless hideDecimalIfZeros is set, in which case only show decimal places when not .00 (used in Finance summary)
  let minimumFractionDigits;

  if (props.hideDecimalIfZeros) {
    minimumFractionDigits = props.value % 1 === 0 ? 0 : 2; // show minimum 2 decimal places except when .00
  } else {
    minimumFractionDigits =
      props.minimumFractionDigits === undefined
        ? 2
        : props.minimumFractionDigits;
  }

  return minimumFractionDigits;
};
